import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isLoading: false,
      isNotify: false,
      notifications: [],
      alertMessageDisplay: false,
      alertMessage: {
        display: false,
        text: "Notification placeholder text",
        timeout: 3000,
        class: "success"
      },
      // [matrah] stacked toasts (components/global/Notification.vue). setAlertMessage() feeds it.
      toasts: [],
      toastSeq: 0,
    }
  },
  getters: {
    getNotifications(state){
      return state.notifications;
    },
    alertMessage(state){
      console.log("alertMessage ", state.alertMessage)
      return state.alertMessage ?? {
        display: false,
        text: "Notification placeholder text",
        timeout: 10000,
        class: "success"
      };
    },
    getAlertMessageDisplay(state){
      console.log("alertMessage ", state.alertMessage)

      return  state.alertMessageDisplay
    }
  },
  actions: {
    disableLoading() {
      this.isLoading = false
    },
    enableLoading() {
      this.isLoading = true
    },
    setNotifications(data){
      this.notifications = data;
    },
    appendNotifications(data){
      this.notifications.push(data);
    },
    resetNotify() {
      this.isNotify = false
    },
    setNotify() {
      this.isNotify = true
    },
    setAlertMessage(data) {
      console.log({data})
     
      this.alertMessage.display = data.display;
      this.alertMessage.text = data.text;
      this.alertMessage.timeout = data.timeout ?? 3000;
      // [matrah] legacy: this.alertMessage.class = data.alertClass;
      // Callers pass `class`; `alertClass` kept for compatibility.
      this.alertMessage.class = data.alertClass ?? data.class ?? 'success';
      this.alertMessageDisplay = data.display

      // [matrah] every displayed alert becomes a stacked toast
      if (data.display && data.text) this.pushToast({ text: data.text, type: this.alertMessage.class, timeout: this.alertMessage.timeout })
    },
    // [matrah] toast queue: success / error / warning / info, auto-hide, max 5 visible,
    // identical toasts within 2 s are merged (e.g. two socket listeners reporting the same failure).
    pushToast({ text, type = 'info', timeout = 3000 }) {
      const kind = type === 'erroe' ? 'error' : ['success', 'error', 'warning', 'info'].includes(type) ? type : 'info'
      const now = Date.now()
      const duplicate = this.toasts.find((t) => t.text === String(text) && t.type === kind && now - t.createdAt < 2000)
      if (duplicate) return duplicate.id
      const id = ++this.toastSeq
      this.toasts.push({ id, text: String(text), type: kind, timeout, createdAt: now })
      if (this.toasts.length > 5) this.toasts.splice(0, this.toasts.length - 5)
      if (timeout > 0) setTimeout(() => this.dismissToast(id), timeout)
      return id
    },
    dismissToast(id) {
      const idx = this.toasts.findIndex((t) => t.id === id)
      if (idx > -1) this.toasts.splice(idx, 1)
      if (!this.toasts.length) {
        this.alertMessage.display = false
        this.alertMessageDisplay = false
      }
    },
  }
})
